import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-table-cell-option-panel',
  templateUrl: './option-panel-table-cell.component.html',
  standalone: false,
})
export class OptionPanelTableCellComponent extends DataTypeComponent implements OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  ngOnDestroy() {}
}
